// The contact page (`/contact.html`): every way to reach the team on one page.
//
// The words are the catalog's, put in by the build, and the chrome is the
// site's. The one behaviour of its own: the chat card's button opens the site's
// chat (shell/chat.html) the way its own launcher does. The card is shown only
// while the chat is open (contact.css, keyed off the class src/chat.ts sets).
//
// NO STRING IS WRITTEN HERE: this site has no i18n runtime by design.
import './audience.css';
import './contact.css';
import './main';

for (const button of document.querySelectorAll<HTMLButtonElement>('[data-chat-open]')) {
  button.addEventListener('click', () => {
    const panel = document.querySelector<HTMLElement>('#sitechat-panel');
    if (panel && !panel.hidden) {
      document.querySelector<HTMLTextAreaElement>('#sitechat-input')?.focus();
      return;
    }
    document.querySelector<HTMLButtonElement>('#sitechat-open')?.click();
  });
}
